import api from '../../../App/socket';

export const addLocationCriteria = (configId, config) => api.send({
    api: 'db',
    model: 'Leadomatic_configuration',
    action: 'NestedCreate',
    options: {
        where: {
            _id: configId,
        },
        fullPath: 'location_criteria',
        create: config,
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_create/requests/add_location_criteria.js